import { render } from "./setbox.vue?vue&type=template&id=3234564a"
import script from "./setbox.vue?vue&type=script&lang=js"
export * from "./setbox.vue?vue&type=script&lang=js"

import "./setbox.vue?vue&type=style&index=0&id=3234564a&lang=less"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__